import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
    ButtonComponent,
    FormFieldComponent,
    InputTextComponent,
} from '@interacta-shared/ui';
import { AdvancedSearchQueryBuilder } from '@modules/header/models/advanced-search/advanced-search.model';
import { advancedSearchQueryBuilder } from '@modules/header/models/advanced-search/advanced-search.utils';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-advanced-search-panel',
    templateUrl: './advanced-search-panel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FormFieldComponent,
        InputTextComponent,
        ButtonComponent,
        TranslatePipe,
    ],
})
export class AdvancedSearchPanelComponent {
    readonly formGroup = input.required<
        FormGroup<{
            some: FormControl<string | null>;
            exactly: FormControl<string | null>;
            every: FormControl<string | null>;
            none: FormControl<string | null>;
        }>
    >();

    readonly closePanel = output<void>();
    readonly advancedSearch = output<AdvancedSearchQueryBuilder>();

    doSearch(): void {
        this.advancedSearch.emit(
            advancedSearchQueryBuilder(this.formGroup().value),
        );
    }
}
